<template>
    <div>
        <v-server-table name="trainingCourseTable" ref="trainingCourseTable" url="/training-courses/list" :columns="columns" :options="options">

            <div slot="afterFilterWrapper" class="ml-md-2 ml-0 mt-md-0 mt-2 mb-md-0 mb-3 float-md-left">
                <div class="clearfix d-md-none d-block"></div>

                <div class="float-left">
                    <table-filters-2 ref="courseTableFilters" v-bind:filters="filters" :emptyFilters="filterDefs" :filterKey="filterKey" filterUrl="/training-courses/filters" @filtersChanged="refreshTableData" @filtersCleared="filtersCleared">
                        <template slot-scope="slotProps">
                            <div class="d-inline-block">
                                <multi-select v-model="slotProps.filters['training_course_catalogs.training_catalog_id']" :btnLabel="(values) => ('Catalogs ('+values.length+')')" :selectOptions="slotProps.filterData.catalogs" :options="{multi: true}"></multi-select>
                            </div>
                        </template>
                    </table-filters-2>
                </div>

                <button type="button" class="btn btn-outline-success ml-2" @click="exportTable()" :disabled="exportingTable">
                    <template v-if="!exportingTable"><i class="fa fa-file-excel-o"></i> Export</template>
                    <template v-else><i class="fa fa-circle-o-notch fa-spin"></i> Exporting</template>
                </button>

                <div class="clearfix d-md-none d-block"></div>
            </div>

            <template slot="id" slot-scope="props">
                <router-link :to="`/training-courses/view/${props.row.id}`" title="View Training Course" class="btn btn-sm btn-secondary">
                    View
                </router-link>
                <router-link  :to="`/training-courses/edit/${props.row.id}`" title="Edit Training Course" class="btn btn-sm btn-light">
                    <i class="fa fa-edit"></i> Edit
                </router-link>
            </template>

            <router-link slot="course_name" slot-scope="props" :to="`/training-courses/view/${props.row.id}`" title="View Training Course">
                {{ props.row.course_name }}
            </router-link>

            <template slot="enable_public_access" slot-scope="props">
                <label class="badge badge-success" v-if="props.row.enable_public_access == 1">Yes</label>
                <label class="badge badge-default" v-else>No</label>
            </template>

            <template slot="enable_anonymous_access" slot-scope="props">
                <label class="badge badge-success" v-if="props.row.enable_anonymous_access == 1">Yes</label>
                <label class="badge badge-default" v-else>No</label>
            </template>

            <!-- <template slot="child_row" slot-scope="props">

            </template> -->

        </v-server-table>
    </div>
</template>

<script>
    import filterExtractor from '@/helpers/TableFilterExtractor';

    export default {
        props: {
            assetType: {
                type: String,
            },

            assetId: {
                type: Number,
            },
        },

        data: function() {
            return {
                exportingTable: false,
                columns: ['id', 'course_name', 'valid_days', 'enable_public_access', 'enable_anonymous_access'],
                options: {
                    headings: {
                        id: 'Actions',
                        course_name: 'Training Course',
                        valid_days: 'Completed Course Days Valid',
                        enable_public_access: 'Public Access',
                        enable_anonymous_access: 'Anonymous Access',
                    },
                    orderBy: {
                        ascending: false,
                        column: 'training_courses.course_name',
                    },
                    requestAdapter: (data) => {
                        //Set the filters
                        data.filters = filterExtractor.extractFilters(this.filters);

                        //INclude the asset
                        data.assetType = this.assetType;
                        data.assetId = this.assetId;

                        //Send it
                        return data;
                    },
                    uniqueKey: 'id',
                },

                filterDefs: {
                    'training_course_catalogs.training_catalog_id': [],
                },

                filterKey: 'trainingCourseFilters',

                openModal: false,
                loading: true,
                saving: false,
                jobsite_id: null,
                jobsite: {},
                jobsiteSheets: [],
                sheets: [],
                errors: {},
            }
        },

        computed: {

            scrollHeight(){
                //Setup
                var height = window.innerHeight * 0.5;

                //Send it
                return height;
            },

            filters(){
                //Check State
                if(this.$store.state.tableFilters.filters[this.filterKey])
                {
                    //Send it
                    return this.$store.state.tableFilters.filters[this.filterKey];
                }

                //Return Definition
                return JSON.parse(JSON.stringify(this.filterDefs));
            },
        },

        methods: {
            refreshTableData(filters) {
                //Set the data
                this.$refs.trainingCourseTable.setPage(1);
                this.$refs.trainingCourseTable.getData();
            },

            filtersCleared(){
                //Reset
                this.refreshTableData();

                //Reset the Columns
                this.$refs.empTableFilters.resetColVis(this.$refs.trainingCourseTable);
            },

            exportTable(){
                //Loading indicator
                this.exportingTable = true;

                //Build the payload
                var payload = {
                    filters: filterExtractor.extractFilters(this.filters),
                    query: (this.$refs.trainingCourseTable.getRequestParams()).query,
                    orderBy: this.$refs.trainingCourseTable.options.orderBy.column,
                    ascending: this.$refs.trainingCourseTable.options.orderBy.ascending,
                    table: 'trainingCourseTable',
                    columns: this.$refs.trainingCourseTable.columns,
                    visible_columns: this.$root.getVisibleColumnsFromState('trainingCourseTable'),
                };

                //Send it
                this.$http.get('/training-courses/list?export=true', payload)
                    .then(response => {
                        //Open the new window
                        window.open(response.data);
                    })
                    .catch(err => {
                        //Alert the user
                        this.$toastr.error(err.response.data, 'Failed to Export Training Courses');
                    })
                    .then(response => {
                        //reset
                        this.exportingTable = false;
                    });
            },
        },
    }
</script>